import { trackEvent, trackPageMeta } from '@farmnet/tag-manager';
import { deleteCookie, getCookie } from '../helper/cookie.ts';

loginController.$inject = [
  '$scope',
  '$rootScope',
  '$http',
  'LoginService',
  'UserSessionStorageService',
  'tracker',
  'i18nFilter',
  '$location'
];

function loginController(
  $scope,
  $rootScope,
  $http,
  LoginService,
  UserSessionStorageService,
  tracker,
  i18nFilter,
  $location
) {
  const SESSION_TIMEOUT_PARAMETER = 'sessionTimeout';
  const LAST_ROUTE_PARAMETER = 'lastRoute';
  /* CFNPOC-10205: Extend here till we reviewed browsercheck.js from /app */
  var controller = this;

  controller.loginAlertAlias = false;
  controller.showRestMsg = false;
  controller.isSessionExpired = isSessionExpired();
  /* Allow forms to register in this controller's scope */
  controller.forms = {};
  $scope.reqPassword = {};
  $scope.reqUsername = {};
  controller.activeTab = 1;
  $scope.welcomeMessage = '';

  controller.isMobile = isMobile;
  controller.showLogin = showLogin;
  controller.login = login;
  controller.logout = LoginService.logoutAndCleanup;
  controller.forgotPwd = forgotPwd;
  controller.reloadForgotPwdCaptcha = reloadForgotPwdCaptcha;
  controller.forgotUsername = forgotUsername;
  controller.reloadForgotUsernameCaptcha = reloadForgotUsernameCaptcha;
  controller.openTab = openTab;

  $scope.hasError = hasError;

  init();

  function init() {
    // check if login form is called from registration controller
    // and set the given alias in the username field
    // delete alias from rootScope after setting it
    //
    // login.html will redirect to login.html#/ so we won't
    // let redirects delete to cookie
    // especially it would lead to double tracking the registration
    var alias = getCookie('alias');
    if (alias && alias.match(/^[A-Za-z0-9\-\_\.@]{4,30}$/)) {
      $scope.username = alias;
      controller.loginAlertAlias = true;
      $scope.welcomeMessage =
        i18nFilter('fe.login.welcome') + i18nFilter('fe.login.welcome.farmnet');

      // track registration
      tracker.trackRegistration();
      // track double opt-in confirmation
      trackEvent(
        'Customer Relations',
        'Account Registration',
        'Double Opt-In'
      );

      // delete cookie
      deleteCookie('alias');
    }

    reloadForgotPwdCaptcha();
    reloadForgotUsernameCaptcha();
  }

  function isSessionExpired() {
    var search = location.search;

    return search.indexOf(SESSION_TIMEOUT_PARAMETER) > -1;
  }

  function getLastRoute() {
    const params = new URLSearchParams(location.search);

    return params.get(LAST_ROUTE_PARAMETER);
  }

  function isMobile() {
    if (jQuery.browser.mobile) return true;
    else return false;
  }

  function showLogin() {
    $('#viewDiv').hide();
    $('#loginDiv').show();
  }

  function beforeRedirect() {
    UserSessionStorageService.clearSession();
  }

  function login() {
    // angular might not know if the browser just changed it.
    $scope.username = $('#username').val();
    $scope.password = $('#password').val();

    app.showLoader();
    LoginService.authenticate({
      username: $scope.username,
      password: $scope.password
    }).then(
      function(creds) {
        app.hideLoader();
        creds = creds || {};

        controller.loginAlert = undefined;
        app.credentials = $rootScope.credentials = creds;
        controller.accountIsLocked = creds.isLocked;

        if ($rootScope.credentials.loggedIn) {

          // track gtm page meta
          trackPageMeta(
            {
              uiCustomerType: 'active'
            }
          );

          tracker.trackEvent('LOGIN', 'logged in');
          beforeRedirect();

          const urlPart = $location.url();
          if (~urlPart.indexOf('landsberg')) {
            window.location = `/genericFarmMap/PrecisionFarming`;
          } else {
            const lastRoute = getLastRoute();
            window.location = `${lastRoute || '/'}`;
          }
        } else {
          controller.loginAlert = true;
          $scope.password = '';
        }
      },
      function() {
        app.hideLoader();
        controller.loginAlert = true;
      }
    );

    return false;
  }

  function forgotPwd() {
    $scope.submitted = true;

    app.showLoader();
    $http
      .post('/365FarmNet/rest/account/forgot_password', $scope.reqPassword)
      .then(
        function() {
          app.hideLoader();
          controller.showRestMsg = true;
        },
        function(httpResponse) {
          const reason = httpResponse.data;
          if ('captcha' === reason) {
            controller.reloadForgotPwdCaptcha();
            controller.captchaInvalid = true;
          }
        }
      );
  }

  function reloadForgotPwdCaptcha() {
    controller.forgotPwdCaptchaSrc =
      '../captcha?p=forgotPassword&' + Math.random();
    $scope.reqPassword.captcha = '';
  }

  function forgotUsername() {
    $scope.submitted = true;

    app.showLoader();
    $http
      .post('/365FarmNet/rest/account/forgot_username', $scope.reqUsername)
      .then(
        function() {
          app.hideLoader();
          controller.showRestMsg = true;
        },
        function(httpResponse) {
          var reason = httpResponse.data;
          if ('captcha' === reason) {
            controller.reloadForgotUsernameCaptcha();
            controller.captchaInvalid = true;
          }
        }
      );
  }

  function reloadForgotUsernameCaptcha() {
    controller.forgotUsernameCaptchaSrc =
      '../captcha?p=forgotUsername&' + Math.random();
    $scope.reqUsername.captcha = '';
  }

  function hasError(formField, validationRule) {
    if (formField === undefined) return;

    if (validationRule)
      return (
        (formField.$dirty || $scope.submitted) &&
        formField.$error[validationRule]
      );
    else return (formField.$dirty || $scope.submitted) && formField.$invalid;
  }

  function openTab(tabOpen) {
    this.activeTab = tabOpen;
  }
}

export default loginController;
